// Pure formatting helpers for the call-volume page. Kept free of React/DOM so
// they can be unit-tested in isolation.

/** Build the `YYYY-MM` API parameter from a 1-based month. */
export function buildMonthParam(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, '0')}`;
}

/** `YYYY-MM-DD` → `DD.MM.` for chart x-axis ticks. */
export function dayLabel(date: string): string {
  const [, month, day] = date.split('-');
  return `${day}.${month}.`;
}

/** `YYYY-MM-DD` → localized long date (weekday + date) for chart tooltips. */
export function tooltipLabel(date: string): string {
  return new Date(`${date}T00:00:00`).toLocaleDateString('de-DE', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
